/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RecentVisitFromJSON, RecentVisitToJSON } from './RecentVisit';
/**
 * Check if a given object implements the RecentVisitsResponse interface.
 */
export function instanceOfRecentVisitsResponse(value) {
    if (!('visits' in value) || value['visits'] === undefined)
        return false;
    return true;
}
export function RecentVisitsResponseFromJSON(json) {
    return RecentVisitsResponseFromJSONTyped(json, false);
}
export function RecentVisitsResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'visits': (json['visits'].map(RecentVisitFromJSON)),
    };
}
export function RecentVisitsResponseToJSON(json) {
    return RecentVisitsResponseToJSONTyped(json, false);
}
export function RecentVisitsResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'visits': (value['visits'].map(RecentVisitToJSON)),
    };
}
